// DEPRECATION NOTICE: Originally from UG LMS, should be removed. https://descomplica.slack.com/archives/CJFJQQY1K/p1713359793357089

import { MicrocertificateModel } from '@/models/microcertificates/microcertificate.model';
import { MutationTree } from 'vuex';
import { MicrocertificateState } from './state';

const mutations: MutationTree<MicrocertificateState> = {
  SET_MICROCERTIFICATES(state, microcertificates: MicrocertificateModel[]) {
    state.microcertificates = microcertificates;
  },
  SET_GENERATING_MICROCERTIFICATE(state, generating: boolean) {
    state.isGenerating = generating;
  },
};

export default mutations;
